import React, { Component } from "react";
import CheckboxItemLayout from "../../../../../../components/checkbox-item/checkbox-item-layout";
import InputBox from "../../../../../../components/input-box/input-box";
import SearchBox from "../../../../../../components/search-box-mediadores/search-box";
import { ValueFormHealthAddress } from "../../../../../../constants/health";
import AddressServices from "../../../../../../services/AddressServices";
import { AddressDataDto, DefaultAddressDataDto, AddressDataItem } from "./address-form-item-dto";
import { HealthAddressFormContainer } from "./address-form-item-style";
import InfoModal from "../../../../../../components/info-modal";
import { images } from "../../../../../../assets";
import DicotomicCheckbox from "../../../../../../components/dicotomic-checkbox/dicotomic-checkbox";
import { deepGet } from "../../../../../../utils/utility";
import TooltipBox from "../../../../../../components/tooltip-box/tooltip-box";
import { HealthAddressFormProps, HealthAddressFormState } from "./address-form-item-types";
import { getChangeNormalizedAddress, getFormatedAddressData, getValidFormattedData, getPreviousData, getStoredPreviousData, validateNoErrors } from "./helpers";

export interface AddressData {
    address: AddressDataItem;
    wayType: string;
    number: string;
    portal?: string;
    stairs?: string;
    floor?: string;
    door?: string;
    postalCode: string;
    town: AddressDataItem;
    province: AddressDataItem;
    sameAsTaker: boolean;
    normalizaDireciones: "N" | "S";
    country?: AddressDataItem;
}

class HealthAddressFormItem extends Component<HealthAddressFormProps, HealthAddressFormState> {

    private _searchWaiter: any = null;

    constructor(props: HealthAddressFormProps) {
        super(props);
        this.state = {
            addressData: DefaultAddressDataDto({ defaultCountry: { value: "ESPAÑA", code: "ESPA" } }),
            provinces: [],
            cities: [],
            streets: [],
            postalCodes: [],
            previousData: DefaultAddressDataDto({ defaultCountry: { value: "ESPAÑA", code: "ESPA" } }),
            showModal: false,
            infoModalText: '',
            showAddressTooltip: false,
            countriesFiltered: [],
        }
    }

    componentDidMount() {
        if (!this.props.insured && this.props.taker !== undefined) {
            this.completeFormTakerData();
        }
        if (this.props.insured && this.props.taker !== undefined && this.state.addressData.sameAsTaker) {
            this.completeFormTakerData();
        }
        if (this.props.insured && !this.props.useTakerData) {
            this.completeInsuredData(this.props.insuredIndex, this.props.insureds);
        }
    }

    componentWillReceiveProps(nextProps: HealthAddressFormProps) {
        let { validate, onCleanForm } = this.props;
        if (nextProps.validate.validateRequest) {
            validate.validateRequest = false;
            validate.isValidated = this.validateForm();
        }
        else if (nextProps.onCleanForm) {
            this.cleanForm();
            onCleanForm = false;
        }

        if (nextProps.insuredIndex !== undefined && nextProps.insuredIndex !== -1 && this.props.insuredIndex !== nextProps.insuredIndex) {
            this.completeInsuredData(nextProps.insuredIndex, nextProps.insureds);
        } else if (nextProps.useTakerData && !nextProps.onCleanForm) {

            if (
                !(this.state.addressData && this.state.addressData.sameAsTaker) 
                && 
                ((nextProps.insureds && nextProps.insureds[nextProps.insuredIndex] && nextProps.insureds[nextProps.insuredIndex].sameAsTaker)
                || (nextProps.useTakerData))
            ) {
                let newAddressData = this.state.addressData;
                newAddressData.sameAsTaker = !newAddressData.sameAsTaker;
                this.storePreviousData();
                this.completeFormTakerData();
                this.setState({ addressData: newAddressData });
            }
        }
        if (nextProps.isPersonalCheckChanging && !nextProps.useTakerData) {
            this.getPreviousData();
        }
        if (
            (nextProps.isForeignAddressAllowed !== this.props.isForeignAddressAllowed)
            && nextProps.isTaker
            && nextProps.taker
            && nextProps.taker.normalizaDireciones === "S"
            && nextProps.taker.country
            && nextProps.taker.country.code !== "ESPA"
        ) {
            this.handleChangeNormalizedAddress(false);
        }
    }

    handleCheckTakerChange(e:  React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.checked;

        let { addressData } = this.state
        const { useTakerData, usePersonalTakerData } = this.props;

        if (value) {
            if (!addressData.sameAsTaker) {
                this.storePreviousData();
                this.completeFormTakerData();
                this.props.onAnyChange()
                this.props.onCheckTakerData(true);
            }
        }
        else if (!value && !usePersonalTakerData) {
            this.getPreviousData();
            this.props.onCheckTakerData();
        }

    }

    storePreviousData() {
        const previousData = getStoredPreviousData(this.state.addressData);
        this.setState({ previousData })
    }

    getPreviousData() {
        const { previousData, addressData } = getPreviousData(this.state.previousData, this.state.addressData)
        this.setState({ previousData, addressData });
    }

    completeInsuredData(index: number, insureds: AddressData[] | undefined) {
        let currentInsured = insureds ? insureds[index] : undefined;
        if (currentInsured) {
            if (currentInsured.sameAsTaker) {
                this.completeFormTakerData();
            } else if (currentInsured.postalCode && !currentInsured.province && currentInsured.normalizaDireciones !== "N") {
                // Si viene de simulación y sólo tiene el Código Postal
                // se limpia el formulario para priorizar la dirección normalizada
                this.cleanForm();
            }
            else {
                this.setAddressData(currentInsured, currentInsured.sameAsTaker);
            }
        }
        else {
            this.cleanForm();
        }
    }

    setAddressData(newData: AddressData, disabled: boolean) {
        const addressData = getFormatedAddressData(this.state.addressData, newData, disabled);
        this.setState({ addressData });
    }

    completeFormTakerData() {
        const { taker, insured } = this.props;
        if (taker && Object.keys(taker).length > 0) {
            taker.sameAsTaker = true;
            this.setAddressData(taker, insured === true)
        }
    }

    handleChangeNormalizedAddress = (value: boolean) => {
        const { addressData } = this.state;
        const normalizaDireciones = value ? "N" : "S";
        addressData.normalizaDireciones = normalizaDireciones;
        this.props.onAnyChange();
        const newAddressData = getChangeNormalizedAddress(addressData, normalizaDireciones);
        this.setState({ addressData: newAddressData });
    }

    async handleFormChange(value: any, input: string): Promise<void> {
        let { addressData } = this.state
        this.props.onAnyChange();
        const normalizaDireciones = addressData.normalizaDireciones === "S";
        switch (input) {
            case "number":
            case "stairsValue":
            case "portalValue":
            case "doorValue":
            case "floorValue":
                value = value.toUpperCase();
                Object.keys(addressData).forEach((k: string) => {
                    if (k === input) {
                        if (addressData[k].value.length === 0) {
                            addressData[k].errorCode = '';
                        }
                        addressData[k].value = value;
                    }
                })
                this.setState({ addressData });
                break;

            case "province":
            case "town":
            case "postalCode":
                Object.keys(addressData).forEach((k: string) => {
                    if (k === input) {
                        if (addressData[k].value.length === 0) {
                            addressData[k].errorCode = '';
                        }
                        addressData[k].value = value.label;
                        addressData[k].code = value.value;
                    }
                })

                if (input === 'province' && normalizaDireciones) {
                    addressData.town.disabled = false;
                    addressData.address.disabled = true;
                    addressData.postalCode.disabled = true;
                    addressData.provinceLabel = value.label;

                }
                // Si la provincia no normalizada se modifica teniendo ya el código postal
                // se añade el código de la provincia desde el código postal
                else if (input === 'province' && !normalizaDireciones && addressData.postalCode.value.length === 5) {
                    addressData.province.code = addressData.postalCode.value.slice(0, 2);
                }
                else if (input === 'town' && normalizaDireciones) {
                    addressData.address.disabled = false;
                    addressData.postalCode.disabled = true;
                }
                else if (!normalizaDireciones && input === 'postalCode' && value.value.length === 5 /*&& addressData.country.code === "ESPA"*/) {
                    addressData.province.code = value.value.slice(0, 2);
                }
                else if (!normalizaDireciones && input === 'province' && addressData.postalCode.value.length === 5) {
                    addressData.province.code = addressData.postalCode.value.slice(0, 2);
                }

                this.setState({ addressData });
                break;
            case "address":
                addressData.postalCode.disabled = false;
                addressData.wayType = normalizaDireciones ? value.extra.street.code : "CALLE";
                if (addressData.address.value.length === 0) {
                    addressData.address.errorCode = '';
                }
                addressData.address.value = normalizaDireciones ? value.extra.street.name : value.value;
                addressData.address.label = value.label;
                addressData.address.code = value.value;
                break;
            case "country":
                addressData.country.value = value.label.toUpperCase();
                addressData.country.code = value.value;
                addressData.country.errorCode = '';
                this.handleChangeNormalizedAddress(value.value !== "ESPA");
                break;
        }
        this.setState({ addressData })
        let formatedStreet = addressData.address.value;
        if (addressData.wayType) {
            formatedStreet = addressData.wayType + " " + formatedStreet
        }
        //Comprobación código INE
        if (this.checkAddresComplete() && normalizaDireciones) {
            let resAddressCheck = await AddressServices.getAddressCheck({
                city: addressData.town.value,
                street: formatedStreet,
                house: addressData.number.value,
                zip: addressData.postalCode.value,
                loader: true,
                setLoading: this.props.setLoading
            });

            if (resAddressCheck && resAddressCheck.length > 0) {
                addressData.postalCode.errorCode = '';
                addressData.province.errorCode = '';
                addressData.town.errorCode = '';
                addressData.number.errorCode = '';
                addressData.address.errorCode = '';
                this.setState({ addressData });
            }
            else {//Cuando la dirección no es válida
                addressData.postalCode.errorCode = 'invalid-address';
                addressData.province.errorCode = 'invalid-address';
                addressData.town.errorCode = 'invalid-address';
                addressData.number.errorCode = 'invalid-address';
                addressData.address.errorCode = 'invalid-address';
                this.setState({ addressData });
                if(resAddressCheck.data.message){
                    this.setState({showModal : true, infoModalText: resAddressCheck.data.message});
                }
            }
        }
    }
    checkAddresComplete(): boolean {
        const { addressData } = this.state;

        if (addressData.address.value !== '' &&
            addressData.town.value !== '' &&
            addressData.number.value !== '' &&
            addressData.postalCode.value !== '')
            return true

        return false;
    }

    validateForm(): boolean {
        let { addressData } = this.state;
        const { isVisaProduct } = this.props;
        const { noErrors, addressData: validatedAddressData } = validateNoErrors(addressData);

        if (noErrors) {
            const validFormattedData = getValidFormattedData(validatedAddressData, isVisaProduct)
            this.props.onValidated(validFormattedData);
        }
        this.setState({ addressData: validatedAddressData });
        return noErrors;
    }

    cleanForm() {
        let { addressData, streets, postalCodes, provinces, cities } = this.state;

        addressData = DefaultAddressDataDto({ defaultCountry: { value: "ESPAÑA", code: "ESPA" } });
        streets = [];
        postalCodes = [];
        provinces = [];
        cities = [];

        this.setState({ addressData, streets, postalCodes, provinces, cities });
    }

    getProvinces = async (input: string, block: string) => {
        const { setLoading } = this.props;
        let { addressData } = this.state;
        const resProvinces = await AddressServices.getProvinces({
            loader: false,
            setLoading: setLoading,
            params: [`input=${input}`],
        });
        const provinces = resProvinces.map((p: any) => ({
            label: p.name,
            value: p.code,
        }));
        addressData.town.value = "";
        addressData.address.value = "";
        addressData.address.label = "";
        addressData.postalCode.value = "";
        addressData.number.value = "";
        addressData.doorValue.value = "";
        addressData.stairsValue.value = "";
        addressData.floorValue.value = "";
        addressData.portalValue.value = "";

        this.setState({
            provinces,
            cities: [],
            streets: [],
            postalCodes: [],
            addressData
        });
    };

    getCities = async (input: string, block: string) => {
        const { setLoading } = this.props;
        const { addressData } = this.state;
        const resCities = await AddressServices.getCities({
            loader: false,
            setLoading: setLoading,
            params: [
                `input=${input}`,
                `provinceCode=${addressData.province.code}`,
            ],
        });
        const cities = resCities.map((p: any) => ({
            label: p.name,
            value: p.code,
        }));
        addressData.address.value = "";
        addressData.postalCode.value = "";
        addressData.number.value = "";
        addressData.doorValue.value = "";
        addressData.stairsValue.value = "";
        addressData.floorValue.value = "";
        addressData.portalValue.value = "";

        this.setState({ cities, streets: [], postalCodes: [], addressData });
    };

    getStreets = async (input: string, block: string) => {
        const { setLoading } = this.props;
        const { addressData } = this.state;
        const resStreets = await AddressServices.getStreets({
            loader: false,
            setLoading: setLoading,
            params: [
                `input=${input}`,
                `provinceCode=${addressData.province.code}`,
                `cityCode=${addressData.town.code}`,
            ],
        });
        addressData.postalCode.value = "";
        const streets = resStreets.map((p: any) => ({
            label: `${p.extra.street.code} ${p.extra.street.name}`,
            value: p.code,
            extra: p.extra,
        }));
        addressData.postalCode.value = "";
        addressData.number.value = "";
        addressData.doorValue.value = "";
        addressData.stairsValue.value = "";
        addressData.floorValue.value = "";
        addressData.portalValue.value = "";
        this.setState({ streets, postalCodes: [], addressData });
    };

    getPostalCodes = async (input: string, block: string) => {
        const { setLoading } = this.props;
        const { addressData } = this.state;
        const resPostalCodes = await AddressServices.getPostalCodes({
            loader: false,
            setLoading: setLoading,
            params: [
                `input=${input}`,
                `provinceCode=${addressData.province.code}`,
                `cityCode=${addressData.town.code}`,
                `street=${addressData.address.code}`,
            ],
        });
        const postalCodes = resPostalCodes.map((p: any) => ({
            label: p.name,
            value: p.name,
        }));

        this.setState({ postalCodes });
    };

    changeValueSearchBox = (ev: React.ChangeEvent<HTMLInputElement>, block: string, key: string = "") => {
        const { provinces, cities, streets, postalCodes, addressData } = this.state;

        if (this._searchWaiter) {
            clearInterval(this._searchWaiter);
        }
        const value: string = ev.target.value;
        if (key === "country") {
            return this.getFilteredCountries(value);
        }

        if (value.length < 2) return;

        this._searchWaiter = setTimeout(async () => {
            switch (key) {
                case "province":
                    if (
                        !provinces[0] ||
                        provinces[0].label.toLowerCase() !== value.toLowerCase()
                    ) {
                        this.getProvinces(value, block);
                    }
                    break;
                case "city":
                    if (
                        !cities[0] ||
                        cities[0].label.toLowerCase() !== value.toLowerCase()
                    ) {
                        this.getCities(value, block);
                    }
                    break;
                case "postalCode":
                    if (
                        !postalCodes[0] ||
                        postalCodes[0].label.toLowerCase() !== value.toLowerCase()
                    ) {
                        this.getPostalCodes(value, block);
                    }
                    break;
                case "street":
                    if (
                        !streets[0] ||
                        streets[0].label.toLowerCase() !== value.toLowerCase()
                    ) {
                        this.getStreets(value, block);
                    }
                    break;
                default:
                    break;
            }
        }, 400);
    };

    getFilteredCountries = (value: string) => {
        const { countries } = this.props;

        if (value.length < 2) return;
        if (value.length >= 2 && countries && countries.length > 0) {
            this.setState({
                countriesFiltered: countries.filter((country) =>
                    country.label.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                    .includes(value.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""))
                ),
            });
        }
    };

    showCountry = () => {
        const { isForeignAddressAllowed, isTaker, isVisaProduct} = this.props;
        return isForeignAddressAllowed && isTaker && isVisaProduct;
    }

    getAddressTitleTooltip = (productFields: any) => {
        const { isTaker } = this.props;
        if (!productFields) return "";
        if (isTaker) {
            return deepGet(productFields, "step1.takerAddressTitleTooltip.tooltip", "");
        }
        return deepGet(productFields, "step2.addressTitleTooltip.tooltip", "");
    }

    render() {
        const { addressData,
            provinces,
            cities,
            streets,
            postalCodes,
            showModal,
            showAddressTooltip,
            countriesFiltered,
        } = this.state

        const { isReadOnly, productFields, isForeignAddressAllowed, insured, isVisaProduct, taker } = this.props;
        const normalizaDireciones = addressData.normalizaDireciones === "S";
        const addressTitleTooltip = this.getAddressTitleTooltip(productFields);
        const takerCountry: string = deepGet(taker, "country.code", "") || "";

        return (
            <HealthAddressFormContainer>
                <div className="content-wrapper bottomMargin20" ref={''}>
                    <div className="personal-data-wrapper" id="data-address">
                        <div className="data-title">
                            <h5>
                                DATOS DOMICILIO
                                {addressTitleTooltip && (
                                    <div className="data-title-tooltip">
                                        <img
                                            src={images.IconInfoBlue}
                                            alt=""
                                            onMouseEnter={() => this.setState({ showAddressTooltip: true})}
                                            onMouseLeave={() => this.setState({ showAddressTooltip: false })}
                                        />
                                        {showAddressTooltip && 
                                            <div className="data-title-tooltip-container">
                                                <TooltipBox
                                                    active={showAddressTooltip}
                                                    tooltipTitle={addressTitleTooltip}
                                                    tooltipText={""}
                                                    leftArrow
                                                    left={""} 
                                                    top={""}
                                                />
                                            </div>
                                        }
                                    </div>
                                )}
                            </h5>
                        </div>

                        <div className="colSin-100">
                            {((insured && !isVisaProduct) || (insured && isVisaProduct && takerCountry === "ESPA")) && (
                                <CheckboxItemLayout
                                    name='Los datos del domicilio son los mismos que los del tomador'
                                    checked={addressData.sameAsTaker}
                                    onChange={(e:  React.ChangeEvent<HTMLInputElement>) => this.handleCheckTakerChange(e)}
                                    showError={false}
                                    checkboxText='Los datos del domicilio son los mismos que los del tomador'
                                    errorText='Error'
                                    disabled={isReadOnly}
                                />
                            )}
                            {insured && isVisaProduct && takerCountry !== "ESPA" && (
                                <CheckboxItemLayout
                                    name='Los datos del domicilio son los mismos que los del tomador'
                                    checked={false}
                                    onChange={() => {}}
                                    showError={false}
                                    checkboxText='Domicilio del tomador no elegible por no estar ubicado en España.'
                                    errorText='Error'
                                    disabled
                                />
                            )}

                            {this.showCountry() && (
                                <div className="colSin-33 rightPadding20 bottomMargin20 topMargin20">
                                    <div className="inputBox">
                                        <SearchBox
                                            onChange={(ev: React.ChangeEvent<HTMLInputElement>) =>
                                                this.changeValueSearchBox(ev, "address", "country")
                                            }
                                            errorCode={addressData.country.errorCode}
                                            onSelect={(item: string) => this.handleFormChange(item, "country")}
                                            required
                                            disabled={addressData.country.disabled || isReadOnly}
                                            withLoader={true}
                                            initialValue={addressData.country.value}
                                            optionsText={countriesFiltered as { [key: string]: string }[]}
                                            optionKey={"code"}
                                            optionValue={"label"}
                                            labelText=""
                                        />
                                        <label>PAÍS</label>
                                    </div>
                                </div>
                            )}

                            <div className="colSin-33 rightPadding20 bottomMargin20 topMargin20">
                                {normalizaDireciones ? (
                                    <div className="inputBox">
                                        <SearchBox
                                            onChange={(ev: any) =>
                                                this.changeValueSearchBox(ev, "address", "province")
                                            }
                                            errorCode={addressData.province.errorCode}
                                            onSelect={(item: string) => this.handleFormChange(item, "province")}
                                            required
                                            disabled={addressData.province.disabled || isReadOnly}
                                            withLoader={true}
                                            initialValue={addressData.province.value}
                                            optionsText={provinces}
                                            optionKey={"code"}
                                            optionValue={"label"}
                                            labelText=""
                                            notScroll
                                        />
                                        <label>PROVINCIA</label>
                                    </div>
                                ) : (
                                    <div className="inputBox">
                                        <InputBox
                                            placeholder="Provincia"
                                            disabled={addressData.province.disabled || isReadOnly}
                                            required={isForeignAddressAllowed && addressData.country.code !== "ESPA" ? false : true}
                                            errorCode={addressData.province.errorCode}
                                            value={addressData.province.value}
                                            type={"text"}
                                            onChange={(value) =>
                                            this.handleFormChange({ label: value.toUpperCase(), value }, "province")
                                            }
                                            notScroll
                                        />   
                                    </div>
                                )}
                            </div>

                            <div className={`colSin-${this.showCountry() ? "33" : "66"} rightPadding20 bottomMargin20 topMargin20`}>
                                {normalizaDireciones ? (
                                    <div className="inputBox">
                                        <SearchBox
                                            onChange={(ev: any) =>
                                                this.changeValueSearchBox(ev, "address", "city")
                                            }
                                            errorCode={addressData.town.errorCode}
                                            onSelect={(item: string) => this.handleFormChange(item, "town")}
                                            required
                                            disabled={addressData.town.disabled || isReadOnly}
                                            initialValue={addressData.town.value}
                                            optionsText={cities}
                                            optionKey={"code"}
                                            optionValue={"label"}
                                            labelText=''
                                            withLoader={true}
                                            notScroll
                                        />
                                        <label>POBLACIÓN</label>
                                    </div>
                                ) : (
                                    <div className="inputBox">
                                        <InputBox
                                            placeholder="Población"
                                            disabled={addressData.town.disabled || isReadOnly}
                                            required
                                            errorCode={addressData.town.errorCode}
                                            value={addressData.town.value}
                                            type={"text"}
                                            onChange={(value) => this.handleFormChange({ label: value.toUpperCase(), value }, "town")}
                                            notScroll
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="colSin-100 rightPadding20 bottomMargin20">
                                {normalizaDireciones ? (
                                    <div className="inputBox">
                                        <SearchBox
                                            onChange={(ev: any) =>
                                                this.changeValueSearchBox(ev, "address", "street")
                                            }
                                            errorCode={addressData.address.errorCode}
                                            onSelect={(item: string) => this.handleFormChange(item, "address")}
                                            required
                                            disabled={addressData.address.disabled || isReadOnly}
                                            initialValue={addressData.address.label}
                                            optionsText={streets}
                                            optionKey={"code"}
                                            optionValue={"label"}
                                            labelText=''
                                            withLoader={true}
                                            notScroll
                                        />
                                        <label>DOMICILIO</label>
                                    </div>
                                ) : (
                                    <div className="inputBox">
                                        <InputBox
                                            placeholder="Domicilio"
                                            disabled={addressData.address.disabled || isReadOnly}
                                            required
                                            errorCode={addressData.address.errorCode}
                                            value={addressData.address.label}
                                            type={"text"}
                                            onChange={(value) => this.handleFormChange({ label: value.toUpperCase(), value }, "address")}
                                            notScroll
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="colSin-20 rightPadding20 bottomMargin20">

                                <div className="inputBox">
                                    <InputBox
                                        errorCode={addressData.number.errorCode}
                                        onChange={(value: string) => this.handleFormChange(value, "number")}
                                        placeholder="NÚMERO/KM"
                                        required
                                        disabled={addressData.number.disabled || isReadOnly}
                                        type={"text"}
                                        maxLength={10}
                                        value={addressData.number.value}
                                    />
                                </div>
                            </div>

                            <div className="colSin-20 rightPadding20 bottomMargin20">
                                <div className="inputBox">
                                    <InputBox
                                        onChange={(value: string) => this.handleFormChange(value, "portalValue")}
                                        placeholder="PORTAL"
                                        type={"number"}
                                        disabled={addressData.portalValue.disabled || isReadOnly}
                                        maxLength={5}
                                        value={addressData.portalValue.value}
                                    />
                                </div>
                            </div>

                            <div className="colSin-20 rightPadding20 bottomMargin20">
                                <div className="inputBox">
                                    <InputBox
                                        onChange={(value: string) => this.handleFormChange(value, "stairsValue")}
                                        placeholder="ESCALERA"
                                        type={"text"}
                                        disabled={addressData.stairsValue.disabled || isReadOnly}
                                        maxLength={5}
                                        value={addressData.stairsValue.value}
                                    />
                                </div>
                            </div>

                            <div className="colSin-20 rightPadding20 bottomMargin20">
                                <div className="inputBox">
                                    <InputBox
                                        onChange={(value: string) => this.handleFormChange(value, "floorValue")}
                                        placeholder="PISO"
                                        type={"text"}
                                        disabled={addressData.floorValue.disabled || isReadOnly}
                                        maxLength={5}
                                        value={addressData.floorValue.value}
                                    />
                                </div>
                            </div>

                            <div className="colSin-20 rightPadding20 bottomMargin20">
                                <div className="inputBox">
                                    <InputBox
                                        onChange={(value: string) => this.handleFormChange(value, "doorValue")}
                                        placeholder="PUERTA"
                                        type={"text"}
                                        maxLength={5}
                                        disabled={addressData.doorValue.disabled || isReadOnly}
                                        value={addressData.doorValue.value}
                                    />
                                </div>
                            </div>

                            <div className="colSin-20 rightPadding20 bottomMargin20">
                                {normalizaDireciones ? (
                                    <div className="inputBox">
                                        <SearchBox
                                            onChange={(ev: any) =>
                                                this.changeValueSearchBox(ev, "address", "postalCode")
                                            }
                                            errorCode={addressData.postalCode.errorCode}
                                            onSelect={(item: string) => this.handleFormChange(item, "postalCode")}
                                            required
                                            disabled={addressData.postalCode.disabled || isReadOnly}
                                            initialValue={addressData.postalCode.value}
                                            optionsText={postalCodes}
                                            optionKey={"code"}
                                            optionValue={"label"}
                                            labelText=''
                                            withLoader={true}
                                            notScroll
                                        />
                                        <label>CÓDIGO POSTAL</label>
                                    </div>
                                ) : (
                                    <div className="inputBox">
                                        <InputBox
                                            required
                                            placeholder="Código postal"
                                            disabled={addressData.postalCode.disabled || isReadOnly}
                                            errorCode={addressData.postalCode.errorCode}
                                            value={addressData.postalCode.value}
                                            maxLength={5}
                                            type={"number"}
                                            onChange={(value) => this.handleFormChange({ label: value, value }, "postalCode")}
                                            notScroll
                                        />
                                    </div>
                                )}
                            </div>

                            {isForeignAddressAllowed && addressData.country.code !=="ESPA"
                                ? ""
                                : (
                                    <div className="colSin-80 rightPadding20 bottomMargin20">
                                        <div className="inputBox">
                                            <DicotomicCheckbox
                                                className={`${addressData.province.disabled || isReadOnly ? "disabled" : "" } optional`}
                                                checkboxText="CONTRATAR CON DIRECCIÓN NO NORMALIZADA"
                                                onChange={(value: boolean) => this.handleChangeNormalizedAddress(value)}
                                                disabled={addressData.province.disabled || isReadOnly}
                                                initChecked={addressData.normalizaDireciones === "N"}
                                            />
                                        </div>
                                    </div>

                                )
                            }
                        </div>
                    </div>
                </div>
                {showModal && (
                    <InfoModal
                    mainText={"Domicilio incorrecto. Por favor, verifique si los datos son correctos o debe modificarlos. "+this.state.infoModalText}
                    close={() => this.setState({ showModal: false })}
                    active={true}
                    img={images.IconInfoBlue}
                    />
                )}
            </HealthAddressFormContainer >
        )

    }
}

export default HealthAddressFormItem;
